<div [class]="labelStyle">
  <h2 role="heading" [attr.aria-level]="ariaLevel" [attr.aria-label]="labelAria" [attr.id]="idTitle" *ngIf="labelDescription">{{labelDescription}}</h2>
  <div *ngIf="label" class="text-rg mt-lg">
    <p class="text-space">
      <span>{{label}}</span>
    </p>
    <span *ngIf="labelLink && ariaLabelLink"
    class="text-button"
    role="button"
    tabindex="0"
    [attr.id]="idLink"
    [attr.aria-label]="ariaLabelLink"
    (click)="sendClickLink.emit()"
    (focus)="focusBtn($event)">
      <span aria-hidden="true">{{labelLink}}</span>
    </span>
  </div>
</div>
